import React, { useEffect } from 'react'
import AppRouter from './router/AppRouter';
import 'antd/dist/antd.css'
import './style/styles.scss'
import { QuestionTypesContextProvider } from './context/QuestionTypesContext';
import { CookieHolder } from './util/CookieHolder';
import { InfoModalContextProvider } from './context/InfoModalContext';


const App = () => {

  useEffect(() => {
    CookieHolder.initialize()
  }, [])

  return (
    <InfoModalContextProvider>
      <QuestionTypesContextProvider>
        <AppRouter />
      </QuestionTypesContextProvider>
    </InfoModalContextProvider>
  )
}

export default App;
